import React from 'react';
import { HomeIcon, CalendarIcon, BookOpenIcon, WrenchIcon, BarChartIcon } from 'lucide-react';
import { Screen } from '../hooks/useAppState';
interface BottomNavProps {
  activeScreen: Screen;
  setActiveScreen: (screen: Screen) => void;
}
export function BottomNav({
  activeScreen,
  setActiveScreen
}: BottomNavProps) {
  const navItems: {
    id: Screen;
    label: string;
    icon: React.ElementType;
  }[] = [{
    id: 'home',
    label: 'Today',
    icon: HomeIcon
  }, {
    id: 'program',
    label: 'Program',
    icon: CalendarIcon
  }, {
    id: 'learn',
    label: 'Learn',
    icon: BookOpenIcon
  }, {
    id: 'tools',
    label: 'Tools',
    icon: WrenchIcon
  }, {
    id: 'tracker',
    label: 'Track',
    icon: BarChartIcon
  }];
  return <nav className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-[430px] bg-white border-t border-black/5 flex pt-2 pb-5 z-[100]" data-id="element-12">
      {navItems.map(item => {
      const Icon = item.icon;
      const isActive = activeScreen === item.id;
      return <div key={item.id} onClick={() => setActiveScreen(item.id)} className="flex-1 flex flex-col items-center cursor-pointer py-1.5 transition-all duration-200" data-id="element-13">
            <Icon className={`w-6 h-6 mb-1 transition-all duration-200 ${isActive ? 'text-sage-dark stroke-[2.5px]' : 'text-text-light stroke-2'}`} data-id="element-14" />
            <span className={`text-[10px] font-medium transition-colors duration-200 ${isActive ? 'text-sage-dark' : 'text-text-light'}`} data-id="element-15">
              {item.label}
            </span>
          </div>;
    })}
    </nav>;
}